import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { defineMessages, injectIntl, intlShape } from 'react-intl';
import { DebounceInput } from 'react-debounce-input';
import { clearFilters, getFieldStyles } from '../../utils/search-utils';

const messages = defineMessages({
  placeholder: {
    id: 'searchField.placeholder',
    defaultMessage: 'Find songs, skills and more...',
  },
});

class SearchField extends PureComponent {
  constructor(props) {
    super(props);
    const { query } = props;
    this.state = { query };
    this.handleChange = this.handleChange.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
  }

  componentDidMount() {
    const { onFocus } = this.props;
    if (this.searchInput) {
      const input = this.searchInput;
      const { length } = input.value;
      input.setSelectionRange(length, length);
      if (!onFocus) input.focus();
      input.addEventListener('focus', this.handleFocus);
    }
  }

  componentDidUpdate(prevProps) {
    const { query } = this.props;
    if (query !== prevProps.query) {
      this.setState({ query }); // eslint-disable-line
    }
  }

  resetFilters() {
    const { filters, instant, updateFilters } = this.props;
    const { query } = this.state;
    const clearedFilters = clearFilters({ instrument: filters.instrument });
    updateFilters(clearedFilters);
    if (instant) {
      this.props.instantSearch(query);
    } else {
      this.props.fullSearch(query);
    }
  }

  handleChange(event) {
    const query = event.target.value;
    this.setState({ query });
    this.resetFilters();
  }

  handleFocus() {
    const { onFocus } = this.props;
    if (onFocus) onFocus();
  }

  render() {
    const { pill, small } = this.props;
    const { formatMessage } = this.props.intl;
    const { buttonStyle, inputStyle } = getFieldStyles(pill, small);
    return (
      <form
        className="search-field br2 overflow-hidden flex justify-between items-stretch"
        data-id="search-field"
        onSubmit={event => {
          event.preventDefault();
          this.resetFilters();
          this.props.onSubmit();
        }}
        method="POST"
      >
        <DebounceInput
          className={inputStyle}
          debounceTimeout={300}
          minLength={1}
          onChange={this.handleChange}
          placeholder={formatMessage(messages.placeholder)}
          inputRef={input => {
            this.searchInput = input;
          }}
          type="text"
          value={this.state.query}
        />
        <button
          className={buttonStyle}
          type="submit"
          style={{ paddingLeft: pill ? '0.75rem' : '' }}
        >
          <span className={`icon-search ${!pill ? 'white mh1' : ''}`} />
        </button>
      </form>
    );
  }
}

SearchField.propTypes = {
  filters: PropTypes.shape({}),
  fullSearch: PropTypes.func.isRequired,
  instant: PropTypes.bool,
  instantSearch: PropTypes.func.isRequired,
  intl: intlShape.isRequired,
  onFocus: PropTypes.func,
  onSubmit: PropTypes.func,
  pill: PropTypes.bool,
  query: PropTypes.string,
  small: PropTypes.bool,
  updateFilters: PropTypes.func.isRequired,
};

SearchField.defaultProps = {
  filters: {},
  instant: false,
  onFocus: null,
  onSubmit: () => {},
  pill: false,
  query: '',
  small: false,
};

export default injectIntl(SearchField);
